<template>
  <div>
    <common-header title="결제하기" :showTitle="true" :showLeftMenu="false" :showClose="true" v-on:onClose="onClose"/>
      <!-- CallbackInfo : {{prePayResult}}     -->
      <iframe name="ezpayFrame" style="margin-top:15.92526vw;width:100%;height:100%;position: absolute;display: block;top: 0;left: 0;">
      <form name="payForm" method="post" ref="form" target="ezpayFrame">
          <input type="hidden" name="sp_order_no"     ref="sp_order_no"   :value = "prePayResult.orderNo">
          <input type="hidden" name="sp_product_nm"   ref="sp_product_nm"    :value = "prePayResult.productName">
          <input type="hidden" name="sp_product_amt"	ref="sp_product_amt"   :value = "prePayResult.price">				 
          <input type="hidden" name="sp_pay_type"		ref="sp_pay_type"   :value = "prePayResult.payMethodType">		
          <input type="hidden" name="sp_mall_id"		ref="sp_mall_id"   :value = "prePayResult.pgmid">	
          <input type="hidden" name="sp_reserved1"	ref="sp_reserved1"   :value = "prePayResult.payInfoJson">	
          <input type="hidden" name="sp_deposit_info"	ref="sp_deposit_info"   :value = "prePayResult.depositInfo">	          
      </form>      
    </iframe>
  </div>
</template>

<script>
import {AppConfig} from '@/config/AppConfig';
import {PaymentConfig} from '@/store/Constraints';
import {PayMethodType,EZPayMethodType,PayMenuType,OrderType,PayActions,PaymentResultCode} from "@/components/AppConstants";
export default {
  // props:['payMethodType'],
  props:['isModal'],  
  beforeMount() {
    console.log(`EzPayView.beforeMount -> PayActions : ${this.payAction}`);    
    console.log(`EzPayView.beforeMount -> PayMethod : ${this.payMethod}`);    
    console.log(`EzPayView.beforeMount -> payMenu : ${this.payMenuType}`);    
    console.log(`EzPayView.beforeMount -> orderType : ${this.orderType}`);
    console.log(`EzPayView.beforeMount -> order : ${JSON.stringify(this.order)}`);
    console.log(`EzPayView.beforeMount -> store : ${JSON.stringify(this.store)}`);
    console.log(`EzPayView.beforeMount -> prePayResult : ${JSON.stringify(this.prePayResult)}`);

    console.log(`EzPayView.beforeMount -> decodeURIComponent => payInfoJson : ${decodeURIComponent(this.prePayResult.payInfoJson)}`);

    if(window.addEventListener) {
      console.log(`EzPayView.beforeMount -> addEventListener`);
      window.addEventListener("message", this.onEZPaymendResult, false);  
    }else if (window.attachEvent) {
      console.log(`EzPayView.beforeMount -> attachEvent`);
      window.attachEvent("onEZPaymendResult", this.onEZPaymendResult, false);
    }
  },

  mounted() {
    this.$refs.form.action = AppConfig.VUE_APP_PAYMENT_API.URL;    
    this.$refs.form.submit();
  },
  computed:{    
    payAction(){
        return this.$store.getters[PaymentConfig.PAY_ACTION];
    },
    payMethod(){
        return this.$store.getters[PaymentConfig.PAY_METHOD];
    },
    payMenuType(){
        return this.$store.getters[PaymentConfig.PAY_MENU_TYPE];
    },    
    orderType(){
        return this.$store.getters[PaymentConfig.ORDER_TYPE];
    },
    order(){
        return this.$store.getters[PaymentConfig.ORDER_DATA];
    },
    store(){
        return this.$store.getters[PaymentConfig.ORDER_STORE];
    },
    prePayResult(){
      return this.$store.getters[PaymentConfig.PRE_PAID_RESULT];
    }

  },
  methods:{
    onClose(e){
      if(window.removeEventListener) {
        window.removeEventListener('message', this.onEZPaymendResult, false);
      } else if (window.attachEvent) {
        window.detachEvent('onEZPaymendResult', this.onEZPaymendResult);
      }

      if(this.isModal){
        this.$modal.hide("EzPayView")
        // this.$modal.hideAll();
        return;
      }
      this.$router.go(-1)
    },
    onEZPaymendResult(event){
      console.log(`EzPayView.methods.onEZPaymendResult -> event : ${JSON.stringify(event)}`);

      var data = event.data;            
      if(data && data.func && data.message && data.func == 'onEZPaymendResult') {
        console.log(`EzPayView.methods.onEZPaymendResult -> data : ${JSON.stringify(data)}`);
        //호출한 페이지로 결과 이벤트 전송
        this.$emit('onPaymentResult',data);
      }
      // if(this.isModal){
      //   this.$modal.hide('EzPayview');
      //   this.$modal.hideAll();
      //   return;
      // }
        



      // // //모달인 경우 화면 닫기
      // // if(this.isModal){        
      // //   this.$modal.hideAll();
      // // }else{
      //   //0:성공,1:취소,2:실패
      //   //{\"func\":\"onEZPaymendResult\",\"message\":\"false\"}"
      //   // if(data.message || data.message == 'true'){
      //   if(data.message == PaymentResultCode.Success){
      //   // if(AppConfig.VUE_APP_IS_DEV){   //성공
      //     if(this.payAction == PayActions.Payment){
      //       // if(this.payMenuType == PayMenuType.Menu){

      //       // }
      //       switch(this.orderType){
      //         case OrderType.MemberShip:
      //           this.$router.push('/order/payprepaid/orderCompleted');
      //           break;
      //         case OrderType.Delivery:
      //           this.$router.push('/order/payprepaid/deliveryCompleted');
      //           break;
      //         case OrderType.EGift:
      //           this.$router.push('/giftshop/payprepaid/deliveryCompleted');
      //           break;

      //       }        
      //     }else if(this.payAction == PayActions.Cancel){
      //       this.$router.push('/order/payprepaid/cancelCompleted');
      //     }
      //   }
      // //   }else if(data.message == PaymentResultCode.Canceled){
      // //     this.$router.go(-1);
      // //   }else{    //실패
      // //     this.$refs.alert.show('결제에 실패하였습니다.',()=>{
      // //           this.$router.go(-1);
      // //       })
      // //   }
      // // }
      
      
      


      

      // // let result = {
      // //   result:true,
      // // }
      // // if(this.isModal)this.$emit('onPaymentResult',result);
      // // else 

      // // if(this.isModal)this.$modal.hideAll();
      // //   else this.$router.go(-1);
    },

    // onMessage(event) {
    //   // Check sender origin to be trusted
    //   // if (event.origin !== "http://example.com") return;
    //   console.log(`EzPayView.methods.onMessage -> event : ${JSON.stringify(event)}`);
    //   var data = event.data;      
    //   console.log(`EzPayView.methods.onMessage -> data : ${JSON.stringify(data)}`);
    //   // if (typeof(window[data.func]) == "function") {
    //       // console.log(`EzPayView.methods.onMessage -> call : ${JSON.stringify(data.func)}(${data.message})`);
    //       // window[data.func].call(null, data.message);
    //   // }

    //   if(typeof data.func === 'function'){
    //       console.log(`EzPayView.methods.onMessage -> call : ${JSON.stringify(data.func)}(${data.message})`);
    //       window[data.func].call(null, data.message);
    //   }
    // },
    
  }
}
</script>
<style scoped>
iframe 
{
 display: block; 
 width: 100%; 
 border: none; 
 overflow-y: auto; 
 overflow-x: hidden;
}
div {
    height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/payment/EzPayView.vue